import { createFileRoute } from '@tanstack/react-router'
import { ActiveCallsPage } from '@/features/operations'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/active-calls/')({
  component: ActiveCallsPage,
  beforeLoad: requireRole(['admin', 'reseller', 'customer']),
})
